import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { RecaptchaActions } from './recaptcha.actions';

@Injectable({
  providedIn: 'root',
})
export class RecaptchaFacade {
  store = inject(Store);

  track(key: string) {
    this.store.dispatch(RecaptchaActions.eventName({ key }));
  }
}
